/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import { setLocalStorage } from '@src/data/localStorage';

const ExpirationCountdown = ({
  courseId, hoursToExpiration, setupgradeNotificationCurrentState, type,
}) => {
  const intl = useIntl();
  let expirationText;
  if (hoursToExpiration >= 24) { // More than 1 day left
    // setupgradeNotificationCurrentState is available in NotificationTray (not course home)
    if (setupgradeNotificationCurrentState) {
      if (type === 'access') {
        setupgradeNotificationCurrentState('accessDaysLeft');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'accessDaysLeft');
      }
      if (type === 'offer') {
        setupgradeNotificationCurrentState('FPDdaysLeft');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'FPDdaysLeft');
      }
    }
    expirationText = intl.formatMessage(
      {
        id: 'advertisements.upgradeNotification.expirationDays',
        defaultMessage: `{dayCount, number} {dayCount, plural,
          one {day}
          other {days}} left`,
        description: 'Text notifying users how many days are left till upgrade expiration',
      },
      {
        dayCount: (Math.floor(hoursToExpiration / 24)),
      },
    );
  } else if (hoursToExpiration >= 1) { // More than 1 hour left
    // setupgradeNotificationCurrentState is available in NotificationTray (not course home)
    if (setupgradeNotificationCurrentState) {
      if (type === 'access') {
        setupgradeNotificationCurrentState('accessHoursLeft');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'accessHoursLeft');
      }
      if (type === 'offer') {
        setupgradeNotificationCurrentState('FPDHoursLeft');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'FPDHoursLeft');
      }
    }
    expirationText = intl.formatMessage(
      {
        id: 'advertisements.upgradeNotification.expirationHours',
        defaultMessage: `{hourCount, number} {hourCount, plural,
          one {hour}
          other {hours}} left`,
        description: 'Text notifying users how many hours are left till upgrade expiration',
      },
      {
        hourCount: (hoursToExpiration),
      },
    );
  } else { // Less than 1 hour
    // setupgradeNotificationCurrentState is available in NotificationTray (not course home)
    if (setupgradeNotificationCurrentState) {
      if (type === 'access') {
        setupgradeNotificationCurrentState('accessLastHour');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'accessLastHour');
      }
      if (type === 'offer') {
        setupgradeNotificationCurrentState('FPDLastHour');
        setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'FPDLastHour');
      }
    }
    expirationText = intl.formatMessage({
      id: 'advertisements.upgradeNotification.expirationMinutes',
      defaultMessage: 'Less than 1 hour left',
      description: 'Text notifying user that how much time is left to upgrade',
    });
  }
  return (<div className="upsell-warning">{expirationText}</div>);
};

ExpirationCountdown.propTypes = {
  courseId: PropTypes.string.isRequired,
  hoursToExpiration: PropTypes.number.isRequired,
  setupgradeNotificationCurrentState: PropTypes.func,
  type: PropTypes.string,
};

ExpirationCountdown.defaultProps = {
  setupgradeNotificationCurrentState: null,
  type: null,
};

export default ExpirationCountdown;
